import { DataContext } from "components/contexts/DataContext"
import { useContext } from "react"

export default function useData() {

    const {data} = useContext(DataContext)

    return data
}